import Nullstack from 'nullstack';
export default function IconToolsKitchen({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-tools-kitchen",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 3h8l-1 9h-6z"
  }), "   ", Nullstack.element("path", {
    d: "M7 18h2v3h-2z"
  }), "   ", Nullstack.element("path", {
    d: "M20 3v12h-5c-.023 -3.681 .184 -7.406 5 -12z"
  }), "   ", Nullstack.element("path", {
    d: "M20 15v6h-1v-3"
  }), "   ", Nullstack.element("line", {
    x1: "8",
    y1: "12",
    x2: "8",
    y2: "18"
  }), " ");
}